import { Type } from 'specified';

const placePredictionsResponseSpec = Type.interface({
    name: Type.string,
    places: Type.array(Type.array(Type.string))
});
const placePredictionsExtendedResponseSpec = Type.interface({
    name: Type.string,
    places: Type.array(Type.interface({
        id: Type.string,
        address: Type.array(Type.string)
    }))
});
const placeDetailsResponseSpec = Type.interface({
    coordinates: Type.interface({
        lat: Type.number,
        lng: Type.number
    })
});
const coordinatesResponseSpec = Type.interface({
    address: Type.string,
    coordinates: Type.interface({
        lat: Type.number,
        lng: Type.number
    })
});

export { coordinatesResponseSpec, placeDetailsResponseSpec, placePredictionsExtendedResponseSpec, placePredictionsResponseSpec };
//# sourceMappingURL=specs.js.map
